document.addEventListener('DOMContentLoaded', function () {
    function openModalById(id) {
        const modalEl = document.getElementById(id);
        if (modalEl && modalEl.classList.contains('modal')) {
            const modal = new bootstrap.Modal(modalEl);
            modal.show();
        }
    }

    if (window.location.hash) {
        const hashId = window.location.hash.replace(/^#\/?/, '');
        openModalById(hashId);
    }

    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href').slice(1);
            const modalEl = document.getElementById(targetId);

            if (modalEl && modalEl.classList.contains('modal')) {
                e.preventDefault();
                openModalById(targetId);
            }
        });
    });
});
